<template>
  <div class="num-pad" v-html="value" v-on:click.prevent="clearValue($event.target.value)"></div>
</template>

<script>
  export default {
    name: 'numInput',
    props: ['value','mode'],
    methods: {
      clearValue(value) {
        this.$emit('isKey', this.mode);
        // this.$refs.input.value = '';
        // this.$el.focus();
      }
    }
  }
</script>

<style lang="scss">
    .num-pad {
      width: 14px;
      border: 1px solid rgba(255,255,255,0);
      border-bottom: 1px solid white;
      height: 3rem;
      text-align: center;
      margin: 0rem 0.2rem 0 0.2rem;
      outline: none;
      &:first-child {
        margin: 0rem 0.2rem 0 0.2rem;
      }
      padding: 0;
      color: black;
      font-size: 2.4rem;
      outline: none;
      // display: flex;
      // align-items: center;
      // justify-content: center;
      font-family: 'UniversLTPro-45Light';
      font-weight: normal;
      // border: 1px solid black;
      // border-bottom: 1px solid rgba(0,0,0,0.3);
      transition: border 0.3s ease-in-out;
      &:focus {
        color: black;
        border: 1px solid black;
      }
    }

</style>


// WEBPACK FOOTER //
// src/components/NumInput.vue